import React from 'react';
import { Typography, Grid } from '@mui/material';
import { env } from 'env';
import createClasses from './styles';
import { useTranslation } from 'react-i18next';

export interface NoResultsProps {
  input: string;
}

export const NoResults = ({ input }: NoResultsProps) => {
  const classes = createClasses();
  const noResultsIconUrl = `${env.REACT_APP_STATIC_ASSETS_URL}/images/Members_No_Results.png`;
  const { t } = useTranslation('globalSearch');

  return (
    <Grid className={classes.container} container>
      <Grid className={classes.textContainer} container spacing={0.5}>
        <Grid item>
          <Typography className={classes.text}>
            {t('globalSearch:no_results')}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.highlight}>{input}</Typography>
        </Grid>
      </Grid>
      <img src={noResultsIconUrl} className={classes.icon} />
    </Grid>
  );
};
